import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import DropdownRight from "./DropdownRight";
import storageService from "../services/Storage";
import upload from "../assets/images/upload.png";
import { useNavigate } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import http from "../services/http";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function Logout() {
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState(0);
  const [error, setError] = useState("");
  const [comments, setComment] = useState([]);
  console.log("comment-----", comments);

  let user = localStorage.getItem("user");
  let token = localStorage.getItem("xAuthToken");
  user = JSON.parse(user);
  const [picture, setPicture] = useState(upload);

  useEffect(() => {
    feedbackStars();
  }, []);

  const signOutUser = () => {
    try {
      storageService.remove("user");
      storageService.remove("xAuthToken");
      storageService.remove("xAuth");
      console.log("user logout ");
      navigate("/");
    } catch (e) {
      console.log("logout error", e);
    }
  };
  const feedbackStars = (e) => {
    http
      .get(`api/analyst/feedbacks?token=${token}`)
      .then((res) => {
        console.log("feedback===>", res.data.feedbacks);
        setFeedback(res.data.avgStars);
        setComment(res.data.feedbacks);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification mb_40 ">
        <div className="login_inner">
          <div className="user_logout">
            {" "}
            {user.data.image ? (
              <img
                // src={upload }
                src={user.data.image}
                alt=""
                style={{ width: 160, height: 160 }}
              />
            ) : (
              <img
                src={upload}
                // src={user.data.image}
                alt=""
                style={{ width: 160, height: 160 }}
              />
            )}
          </div>
          <h1 className="mb_30 main_title ">
            {user.data.firstname} {user.data.lastname}
          </h1>
          <div className="raing_star">
            <div className="rate" style={{}}>
              {feedback !== 0 ? (
                <ReactStars
                  count={5}
                  value={feedback}
                  size={30}
                  activeColor="#ffd700"
                  isHalf={true}
                />
              ) : (
                <div></div>
              )}
            </div>
          </div>
          {comments.length === 0 ? (
            <div>
              <p class="mb_40 them_para text-center mx-auto  mt_100 ">
                <span class="">{""}"</span> No Comments
                <span class=""> "</span>
              </p>
            </div>
          ) : (
            <>
              <Carousel
                arrows={false}
                responsive={responsive}
                infinite={true}
                transitionDuration={500}
                focusOnSelect={true}
                centerMode={true}
              >
                {comments.map((item) => (
                  <div>
                    <p class="mb_40 them_para text-center mx-auto  mt_100 ">
                      <span class="">{""}"</span> {item.comment}
                      <span class=""> "</span>
                    </p>
                  </div>
                ))}
              </Carousel>
            </>
          )}

          <h6 style={{ color: "red" }}>{error}</h6>
          <p
            onClick={signOutUser}
            className="btn-link"
            style={{ cursor: "pointer" }}
          >
            Logout
          </p>
        </div>
      </section>
    </>
  );
}

export default Logout;
